<template>
  <header :class="headerColor">
    <div class="header-inner">
      <template v-if="isShowOnlySearchInput">
        <v-layout class="xs-4" fixed height="50px">
          <Logo :logoStyle="logoStyle" :logoAsset="logoAsset" :serviceName="serviceName" :disabled="isLogoLinkUnClickable" />
        </v-layout>
        <v-flex xs4 h-100 class="overflow-hidden" v-if="isShowUserMenu">
          <div class="menu-wrapper">
            <div class="overflow-hidden">
              <UserPropertyMenu :color="propertyMenuColor" />
            </div>
            <div style="width: auto">
              <v-flex class="header-menu">
                <v-tooltip bottom>
                  <template #activator="{ on }">
                    <a v-on="on" @click="openHelpCenter()" style="width: 50px" class="text-center">
                      <IconButton :color="iconColor">help</IconButton>
                    </a>
                  </template>
                  <span>ヘルプセンターはこちら</span>
                </v-tooltip>
                <!-- NOTE: お問い合わせは一旦非表示 -->
                <!-- <v-tooltip bottom>
                  <template #activator="{ on }">
                    <a v-on="on" @click="openHelpCenter('support')" style="width: 50px" class="text-center">
                      <img :src="$cdnEndpoint + 'img/header/icon_mail.png'" height="22px" />
                    </a>
                  </template>
                  <span>お問い合わせはこちら</span>
                </v-tooltip> -->
                <!-- <UserSettingsMenu :color="iconColor" /> -->
              </v-flex>
            </div>
          </div>
        </v-flex>
        <v-flex xs4 h-100 class="overflow-hidden" v-if="!isShowUserMenu"> </v-flex>
      </template>
    </div>
  </header>
</template>

<script>
import HelpCenterQuery from '@/api/help_center/query.js';

import Logo from '@/components/_atoms/Logo';
import IconButton from '@/components/_atoms/buttons/IconButton';

import UserPropertyMenu from '@/components/_organisms/UserPropertyMenu.vue';
// import UserSettingsMenu from '@/components/_organisms/UserSettingsMenu.vue';

export default {
  name: 'Header',
  props: {
    brand: {
      type: Object
    }
  },
  components: {
    Logo,
    IconButton,
    UserPropertyMenu
    // UserSettingsMenu
  },
  computed: {
    logoStyle() {
      return this.brand.logoColorClass;
    },
    logoAsset() {
      return this.brand.logoAsset;
    },
    serviceName() {
      return this.brand.serviceName;
    },
    headerColor() {
      return this.brand.headColorClass;
    },
    isLightHeader() {
      // 明るい面のヘッダー。文字・アイコンはダークインクにする
      return ['header-brand-white', 'header-brand-ivory'].includes(this.brand.headColorClass);
    },
    iconColor() {
      return this.isLightHeader ? '#26241F' : '#fff';
    },
    propertyMenuColor() {
      return this.isLightHeader ? 'black' : 'white';
    },
    isShowUserMenu() {
      const showUserMenuRouteName = [
        'ContractList',
        'PrioritySettings',
        'CabinetMaster',
        'ClientList',
        'ContractTagList',
        'OriginalLabelList'
      ];
      return showUserMenuRouteName.includes(this.$route.name);
    },
    isShowOnlySearchInput() {
      const hideLogoRouteName = ['ReviewContract'];
      if (hideLogoRouteName.includes(this.$route.name)) {
        return this.$vuetify.breakpoint.width > 960;
      }
      return true;
    },
    isLogoLinkUnClickable() {
      const unLogoClickableRouteName = ['ReviewContract', 'ContractDiff', 'SplitUserTemplate', 'LoginForLeFILING'];
      return unLogoClickableRouteName.includes(this.$route.name);
    },
    isLeFILING: function () {
      return this.$route.name === 'LoginForLeFILING';
    }
  },
  methods: {
    searchJoubun(searchKeyword) {
      this.$store.dispatch('searchJoubun/openWindow', searchKeyword);
    },
    openHelpCenter() {
      HelpCenterQuery.getHelpCenterUrl()
        .then((response) => {
          window.open(response.data.data, '_blank');
        })
        .catch((error) => {
          this.$store.dispatch('message/setErrorMessage', {
            message:
              error.response && error.response.data && error.response.data.error ? error.response.data.error : 'URLの取得に失敗しました。'
          });
        });
    }
  }
};
</script>

<style scoped>
header {
  position: fixed;
  width: 100%;
  z-index: 99;
  height: 50px;
  font-family: 'Noto Sans', sans-serif;
}
/* 面とインクは必ず対で指定する（片方だけ変えると文字が読めなくなる） */
.header-brand {
  background-color: var(--lc-primary);
  color: var(--lc-on-primary);
}
.header-brand-ivory {
  background-color: var(--lc-header-bg);
  color: var(--lc-header-ink);
}
.header-brand-black {
  background-color: #000;
  color: #fff;
}
.header-brand-white {
  background-color: #fff;
  color: var(--lc-ink);
}
/* OEM ブランドはリブランド対象外 */
.header-cloudsign-review {
  background-color: #0d64c9;
  color: #fff;
}
a {
  text-decoration: none;
  color: inherit;
}
ul {
  padding: 0;
}
.header-inner {
  height: 100%;
  margin: 0 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.header-menu {
  height: 100%;
  display: flex;
}
.header-menu a {
  display: flex;
  align-items: center;
  justify-content: center;
}
.header-menu a:hover {
  background-color: var(--lc-header-hover-bg);
}
.header-brand-black .header-menu a:hover {
  background-color: #252525;
}
.header-cloudsign-review .header-menu a:hover {
  background-color: #1571d7;
}

.menu-wrapper {
  display: flex;
  height: 100%;
  justify-content: flex-end;
}

.header-button {
  height: 100%;
  margin: 0;
  text-transform: none;
}

.header-button::before {
  background-color: transparent;
}
.account_card {
  border-radius: 10px;
}
</style>
